import { fetchReducerGenerator } from 'redpoints-front-common/reducers';

import {
  TEST_PURCHASE_CLEAR,
  TEST_PURCHASE_DISCARD_EVIDENCE,
  TEST_PURCHASE_FETCH_LINK_INFO_REQUEST,
} from '../../../actions/actionTypes';

const discardEvidence = fetchReducerGenerator(
  [TEST_PURCHASE_CLEAR, TEST_PURCHASE_FETCH_LINK_INFO_REQUEST],
  TEST_PURCHASE_DISCARD_EVIDENCE
);

export default discardEvidence;
